<template>
  <eg-form-group
    id="upload-type-input-group"
    :description="description"
    label-for="upload-type-input"
    :required="required"
  >
    <template #description>
      <slot name="description"></slot>
    </template>

    <div class="upload-content-area">
      <div v-if="!onlyFiles" class="mb-4">
        <eg-radio-input
          :name="`upload-radio-${_uid}`"
          :value="type"
          :options="uploadOptions"
          @change="changeType"
        />
      </div>
      <uppy-dashboard
        v-if="showFiles"
        ref="uppyDashboard"
        v-model="bulkFiles"
        :path="path"
        :max-number-of-files="maxNumberOfFiles"
        @file-added="$emit('file-added', $event)"
        @file-removed="$emit('file-removed', $event)"
      ></uppy-dashboard>
      <eg-b-form-textarea
        v-if="showTextarea"
        v-model="textContent"
        :rows="rows"
        max-rows="12"
        :state="submitted ? isValid : null"
      ></eg-b-form-textarea>
      <eg-b-form-invalid-feedback v-if="!isValid">
        Text is required.
      </eg-b-form-invalid-feedback>
    </div>
    <slot name="prepend-content"></slot>
  </eg-form-group>
</template>

<script>
import EgFormGroup from "@/components/global/eg_form_group.vue";
import UppyDashboard from "./uppy_dashboard.vue";
import { UPLOAD_TYPE_OPTIONS } from "@/constants";

export default {
  components: {
    EgFormGroup,
    UppyDashboard,
  },

  props: {
    path: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      default: "Upload",
    },

    description: {
      type: String,
      default: "",
    },

    required: {
      type: Boolean,
      default: false,
    },

    rows: {
      type: Number,
      default: 12,
    },

    value: {
      type: String,
      default: "files",
    },

    maxNumberOfFiles: {
      type: Number,
      default: 1,
    },

    submitted: {
      type: Boolean,
      default: false,
    },

    onlyFiles: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      type: "",
      textContent: "",
      singleFile: null,
      bulkFiles: [],
      UPLOAD_TYPE_OPTIONS,
    };
  },

  computed: {
    uploadOptions() {
      return UPLOAD_TYPE_OPTIONS.map((option) => ({
        ...option,
        label: this.$t(option.translationKey),
      }));
    },
    canBulkUpload() {
      return this.$store.getters.userIsNotPausedAndPlanMoreThenPro;
    },

    showFiles() {
      return this.type === "files";
    },

    showTextarea() {
      return this.type === "text";
    },

    isValid() {
      if (this.required && this.showTextarea) {
        return Boolean(this.textContent.trim().length);
      }

      return true;
    },
  },

  watch: {
    textContent() {
      this.$emit("input-text", this.textContent);
    },

    singleFile() {
      this.$emit("input-files", [this.singleFile]);
    },

    bulkFiles() {
      this.$emit("input-files", this.bulkFiles);
    },

    // this watcher is used to ensure a user
    // cannot upload a file in form, switch to text
    // and upload text content and make call to API
    // only one type of data can be sent up
    value() {
      this.type = this.value;

      if (this.value === "text") {
        this.singleFile = null;
        this.bulkFiles = [];
      } else {
        this.textContent = "";
      }
    },
  },

  created() {
    this.type = this.value;
  },

  methods: {
    async upload() {
      if (
        this.$refs.uppyDashboard &&
        this.$refs.uppyDashboard?.uppy?.getFiles()?.length > 0
      ) {
        await this.$refs?.uppyDashboard?.upload();
        await this.$refs?.uppyDashboard?.uppy?.clear();
      }
    },

    changeType(type) {
      this.type = type;
      this.$emit("input", type);
    },
  },
};
</script>
<style scoped lang="scss">
.upload-content-area {
  min-height: 205px;
  display: flex;
  flex-direction: column;
}

.supported-files {
  font-size: 12px;
  color: var(--grey-700);
  margin-bottom: 0;
}
</style>
<style lang="scss">
.start-grading-container {
  .uppy-wrapper {
    margin-bottom: 4px;
  }
  .upload-content-area label.d-block {
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 12px;
  }
}
</style>
